export const left = {
    render: 'Left',
    children: ['paragraph', 'tag', 'list', 'fence'],
};
